<template>
    <div class="ddl-wrapper"
        :class="[{'input-box-error': isSubmitted && isShowError && !errorInfo.isValid}, {'input-disabled': isDisabled}, customClass]">
        <b-dropdown
            class="ddl-input"
            variant="ddl-input"
            menu-class="ddl-menu"
            :text="textValueDropdown">
            <b-dropdown-item
                :disabled="true">
                {{placeholder}}
            </b-dropdown-item>
            <div v-if="!isDisabled" >
                <b-dropdown-item 
                    :disabled="isDisabled"
                    v-for="(v,k) in dropdownList"
                    :key="k"
                    @click="onChange(v)">
                    {{v.text}}
                </b-dropdown-item>
            </div>
        </b-dropdown>
        <div class="ddl-error-txt"
             v-if="isShowError"
             v-show="isSubmitted && !errorInfo.isValid">
            {{errorInfo.msg}}
        </div>
    </div>
</template>
<script>
import Util from "@/helper/Utility.js";
/**
 * Property
 * @property {Object} inputLbl (required) Text for component.
 * @property {Boolean} isFirstSave (required) Show/Hide Error after save.
 * @property {Boolean} isShowErrorLbl (optional) Show/Hide Error label.
 * @property {Object} errorInfo (optional) Validate result. example : { isValid: true, msg: '',}
 * @property {String} addClass (optional) Add css class.
 * @property {Array} itemList (required) item list in dropdown. example : [{ value: '1', text: 'a'}]
 */
export default {
    name: "Dropdown",
    props: {
        //v-model
        value: String,
        //props
        addClass: String,
        errorInfo: Object,
        inputId: String,
        inputLbl: Object,
        isShowError: Boolean,
        isSubmitted: Boolean,
        itemList: Array,
        isDisabled: Boolean,
    },
    data: function() {
        return {
            id: '',
            label: '',
            placeholder: '',
            content: this.value,
            customClass: '',
            textValueDropdown: '',
            dropdownList: [],
        };
    },
    watch: {
        value: function (newVal) {
            if (newVal
                && newVal != this.content) {
                console.log('on watch dropdown', newVal);
                this.content = newVal;
                this.textValueDropdown = newVal;
            }
        }
    },
    mounted: function() { 
        this.id = this.inputId;
        this.label = this.inputLbl.name || '';
        this.placeholder = this.inputLbl.placeholder || '';
        this.customClass = this.addClass || '';
        this.dropdownList = this.itemList;
        this.textValueDropdown = this.placeholder;
        this.initialDefaultValue();
        this.validateInput();
    },
    methods: {
        initialDefaultValue: function() {
            if (Util.isEmptyStr(this.value)) {
                return;
            }

            for (var i of this.dropdownList) {
                if (i.value == this.value) {
                    this.onChange(i);
                    break;
                }
            }
        },
        validateInput: function() {
            if (!this.inputLbl) return;
            //Set default.
            this.errorInfo.isValid = true;
            this.errorInfo.msg = '';
            //Required
            if (this.inputLbl.required
                && Util.isEmptyStr(this.content)) {
                this.errorInfo.isValid = false;
                this.errorInfo.msg = this.inputLbl.required;
                return;
            }
        },
        onChange: function(selected) {
            if (this.isDisabled) {
                return;
            }
            this.content = selected.value;
            this.textValueDropdown = selected.text;

            this.validateInput();
            this.$emit('input', selected.value);
        },
    },
}
</script>
<style lang="scss">
$url-dropdown-icon: url('../../assets/icon/ic-arrow-down-gray.svg');
@import "@/style/Input/Dropdown.scss";

.ddl-wrapper {
    @include baseDropdown('../../assets/icon/ic-arrow-down-gray.svg');
}
.ddl-wrapper.input-disabled .ddl-input .btn-ddl-input {

    color: $gray-A0A0A0;
    border: 1px solid $input-border-color;
    background-color: $input-readonly-bg;
}
</style>
<style lang="scss">
@import "@/style/base/base.scss";
@import "@/style/Input/Text.scss";
.wrap-input {
    @extend %input-base;
} 

</style>
